/* eslint-disable */
import React, {Component} from 'react';

class RegisterInfluencers extends Component {

	constructor(props) {
		super(props);
		this.state = {

		};
	}

	render() {
		return (
			<div className='register-page'>
			</div>
		);
	}

}

export default RegisterInfluencers;



// WEBPACK FOOTER //
// ./src/components/registerInfluencers/registerInfluencers.js